module.exports = __webpack_public_path__ + "img/02572512000743.bab888f6.png";